import { useQuery } from '@tanstack/react-query'
import { profileApi, profilesApi, type PublicProfile, type UserProfileResponse } from '@/lib/api'

/**
 * Query for the currently authenticated user's profile
 */
export function useProfileQuery() {
  return useQuery({
    queryKey: ['profile'],
    queryFn: async () => {
      const response = await profileApi.get()
      return response.data
    },
  })
}

/**
 * Query for a public profile by username
 */
export function usePublicProfile(username: string | undefined) {
  const trimmedUsername = username?.trim()

  return useQuery<PublicProfile>({
    queryKey: ['public-profile', trimmedUsername],
    enabled: Boolean(trimmedUsername),
    queryFn: async () => {
      if (!trimmedUsername) {
        throw new Error('Username is required')
      }
      const response = await profilesApi.getPublic(trimmedUsername)
      return response.data
    },
    staleTime: 1000 * 60,
  })
}

export type ProfileQueryData = UserProfileResponse
